import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './APITest.scss';

const APITest = ({ setTitle }) => {
    const [selectedAPI, setSelectedAPI] = useState('');
    const [params, setParams] = useState({});
    const [result, setResult] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        setTitle('EarthVerse CRM - API Test');
    }, [setTitle]);

    const apis = [
        { name: 'login', endpoint: '/auth/login', method: 'POST', params: ['email', 'password', 'device_token'] },
        { name: 'Get Server', endpoint: '/api/server', method: 'GET', params: [] },
        { name: 'Get permissions', endpoint: 'api/products/permissions/', method: 'GET', params: ['type'] },

    ];

    const handleAPIChange = (e) => {
        const selected = apis.find(api => api.endpoint === e.target.value);
        setSelectedAPI(selected);
        setParams({});
        setResult(null);
        setError(null);
    };

    const handleParamChange = (e) => {
        setParams({ ...params, [e.target.name]: e.target.value });
    };

    const executeAPI = async (endpoint, method, params) => {
        const API_URL = ''; // Adjust this if your API base URL is different
        const url = `${API_URL}${endpoint}`;
        const token = localStorage.getItem('token');
        const headers = token ? { Authorization: `Bearer ${token}` } : {};

        try {
            let response;
            if (method === 'GET') {
                response = await axios.get(url, { headers, params });
            } else if (method === 'POST') {
                response = await axios.post(url, params, { headers });
            }
            return response.data;
        } catch (error) {
            console.error(`Error executing API call to ${endpoint}:`, error);
            throw error;
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        try {
            const response = await executeAPI(selectedAPI.endpoint, selectedAPI.method, params);
            setResult(response);
        } catch (error) {
            setError(error.response?.data?.message || error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="api-test">
            {/* <h2>API Test Page</h2> */}
            <form onSubmit={handleSubmit}>
                <div>
                    <label htmlFor="api-select">Select API:</label>
                    <select id="api-select" value={selectedAPI?.endpoint || ''} onChange={handleAPIChange}>
                        <option value="">Select an API</option>
                        {apis.map((api) => (
                            <option key={api.endpoint} value={api.endpoint}>
                                {api.name} ({api.method})
                            </option>
                        ))}
                    </select>
                </div>
                {selectedAPI && (
                    <div>
                        <h3>Parameters:</h3>
                        {selectedAPI.params.map((param) => (
                            <input
                                key={param}
                                type="text"
                                name={param}
                                placeholder={param}
                                onChange={handleParamChange}
                            />
                        ))}
                    </div>
                )}
                <button type="submit" disabled={!selectedAPI || loading}>
                    {loading ? 'Executing...' : 'Execute API'}
                </button>
            </form>
            {error && (
                <div className="api-error">
                    <h3>Error:</h3>
                    <pre>{error}</pre>
                </div>
            )}
            {result && (
                <div className="api-result">
                    <h3>API Result:</h3>
                    <pre>{JSON.stringify(result, null, 2)}</pre>
                </div>
            )}
        </div>
    );
};

export default APITest;